import * as z from 'zod'
import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import {safeOptional} from '@github-ui/swp-core/schemas/safe-optional'

const LinkFieldsSchema = z.lazy(() =>
  z.object({
    text: z.string(),
    href: z.string(),
    alt: safeOptional(z.string()),
  }),
)

export const LinkSchema = z.union([
  buildEntrySchemaFor('link', {fields: LinkFieldsSchema}),
  buildEntrySchemaFor('flexSuiteLink', {fields: LinkFieldsSchema}),
])

export type Link = z.infer<typeof LinkSchema>

export function isLink(entry: unknown): entry is Link {
  return LinkSchema.safeParse(entry).success
}
